// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// noinspection ES6UnusedImports
import style from "../scss/styles.scss";


const swiperThumbs = new Swiper(".good__photos__thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});
const swiper = new Swiper('.good__photos__big', {
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiperThumbs,
    }
});

const burger = document.getElementById("burger");
burger.addEventListener("click", function(event) {
    event.preventDefault();

    const menu = document.getElementById("site-menu");
    menu.classList.toggle("menu-wrap_open");
});
const closeMenu = document.getElementById("close-menu");
closeMenu.addEventListener("click", function(event) {
    event.preventDefault();

    const menu = document.getElementById("site-menu");
    menu.classList.toggle("menu-wrap_open");
});

const loginLink = document.querySelector(".login-link");
if(loginLink) {
    loginLink.addEventListener("click", function (e) {
        e.preventDefault();

        const menu = document.getElementById("site-menu");
        menu.classList.remove("menu-wrap_open");

        const modal = document.getElementById("login-modal");
        modal.style.display = 'block';
    });
}
const loginClose = document.getElementById("close-login");
if(loginClose) {
    loginClose.addEventListener("click", function (e) {
       e.preventDefault();

        const modal = document.getElementById("login-modal");
        modal.style.display = 'none';
    });
}
const loginForm = document.getElementById("login-form");
if(loginForm) {
    loginForm.addEventListener("submit", function(e) {
        e.preventDefault();

        const login = document.querySelector("input[name=login]").value;
        const password = document.querySelector("input[name=password]").value;

        let data = new FormData();
        data.append( "login", login );
        data.append( "password", password );

        (async () => {
            const rawResponse = await fetch(loginForm.action, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    // 'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: data
            }).then(res => {
                return res.json()
            }).then(data => {
                // console.log(data);

                if(data.result === 'ok') {
                    document.location.reload();
                } else {
                    const errorMsg = document.getElementById("login-error");
                    errorMsg.innerText = data.msg;
                    errorMsg.style.display = 'block';
                }
            }).catch(e => {
                console.error(e);
            });

        })();
    })
}

const loginWrap = document.getElementById("login-modal");
if(loginWrap) {
    loginWrap.addEventListener("click", (e) => {
        e.stopPropagation();

        if(e.target.classList.contains('fader')) {
            loginWrap.style.display = "none";
        }
    });
}


function itemQuantityControl(event) {
    // Клик на + в списке или просмотре товара
    if(event.target.classList.contains("good__counter__plus")) {
        event.preventDefault();

        const input = event.target.parentElement.getElementsByTagName('input')[0];

        if(isNaN(input.value)) {
            input.value = 1;
        }

        input.value = ++input.value;

        const isBasket = document.querySelector(".basket");
        if(isBasket) {
            recalculateBasket();
        }
    }

    // Клик на — в списке или просмотре товара
    if(event.target.classList.contains("good__counter__minus")) {
        event.preventDefault();

        const input = event.target.parentElement.getElementsByTagName('input')[0];

        if(isNaN(input.value)) {
            input.value = 1;
        }

        if(input.value > 0) {
            input.value = --input.value;
        }

        const isBasket = document.querySelector(".basket");
        if(isBasket) {
            recalculateBasket();
        }
    }
}

// Форма в корзине
const basketForm = document.getElementById("cart_form");
if(basketForm) {
    // Слушаем событие click
    document.addEventListener("click", event => {
        // клик по + или -
        itemQuantityControl(event);

        // клик по удалялке
        if (event.target.classList.contains("basket-item__remove")) {
            event.preventDefault();

            if (confirm("Вы действительно хотите удалить товар из корзины?")) {
                const removeButton = event.target;

                fetch(removeButton.href, {
                    method : 'GET',
                    headers: {
                        'Accept'          : 'application/json',
                        // 'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(res => {
                    return res.json()
                }).then(data => {
                    console.log({data});

                    if (data.result === 'ok') {
                        removeButton.closest(".basket-item").remove();
                        recalculateBasket();
                    } else {

                    }
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    // submitBtn.disabled = false;
                    // submitBtn.innerText = "В корзину";
                });
            }
        }
    });
}
const toBasketForms = document.getElementsByClassName("to-basket-form");
if(toBasketForms.length > 0) {

    // Слушаем событие click
    document.addEventListener("click", event => {
        itemQuantityControl(event);
    })

    // Слушаем событие submit
    document.addEventListener("submit", function(event) {

        if(event.target.classList.contains('to-basket-form')) {
            event.preventDefault();

            const toBasketForm = event.target;

            const submitBtn = toBasketForm.querySelector(".good__basket-btn");
            submitBtn.disabled = true;
            submitBtn.innerText = "Добавляем...";

            const data = new FormData(toBasketForm);

            (async () => {
                const rawResponse = await fetch(toBasketForm.action, {
                    method : 'POST',
                    headers: {
                        'Accept'          : 'application/json',
                        // 'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body   : data
                }).then(res => {
                    return res.json()
                }).then(data => {
                    // console.log({data});

                    if (data.result === 'ok') {
                        toBasketForm.querySelector(".item-added").style.display = 'block';
                    } else {

                    }
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    submitBtn.disabled = false;
                    submitBtn.innerText = "В корзину";
                });

                // const content = await rawResponse.json();
            })();
        }
    });
}

function recalculateBasket() {
    const items = document.querySelectorAll(".basket-item");
    if(items && items.length) {

        let sum = 0;

        [...items].map(item => {

            const itemPrice = item.querySelector(".item-price").innerText.replace(' ', '');
            const itemCount = item.querySelector(".good__counter__quantity").value;
            const itemSumWrap = item.querySelector(".item-sum");
            let itemSum = itemPrice * itemCount;

            itemSumWrap.innerText = formatPrice(itemSum);

            sum += itemSum;
        });

        const totalSum = document.querySelector(".total-sum");
        if(totalSum) {
            totalSum.innerText = formatPrice(sum);
        }

        const headerIconBudget = document.querySelector(".menu__basket-count");
        if(headerIconBudget) {
            headerIconBudget.textContent = items.length;
        }

    } else {
        location.reload();
    }
}
const formatPrice = (value) => {
    let val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

document.addEventListener("click", function(event) {
    if (event.target.id === 'other-categories') {
        event.preventDefault();

        event.target.nextSibling.classList.toggle("main-categories-nav_show");
        event.target.style.display = "none";
    }
});

let historyItems = document.querySelectorAll(".history-item__title");
if(historyItems.length) {
    historyItems = Array.from(historyItems);

    historyItems.map(item => {
        item.addEventListener("click", function(event) {
            event.preventDefault();

            const wrapper = item.closest(".history-item");

            const activeOrder = document.querySelector(".history-item_open");
            if(activeOrder && activeOrder.id !== wrapper.id) {
                // console.log(activeOrder.id !== item.id, activeOrder.id + "!==" + item.id);
                activeOrder.classList.remove("history-item_open");
            }

            wrapper.classList.toggle("history-item_open");
        });
    })
}
